import { render, staticRenderFns } from "./ServerRoles.vue?vue&type=template&id=d87351e8&scoped=true&"
import script from "./ServerRoles.vue?vue&type=script&lang=js&"
export * from "./ServerRoles.vue?vue&type=script&lang=js&"
import style0 from "./ServerRoles.vue?vue&type=style&index=0&id=d87351e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87351e8",
  null
  
)

export default component.exports